import { createIcon } from '@chakra-ui/icons';

export const Dropdown = createIcon({
  displayName: 'Dropdown',
  viewBox: '0 0 24 24',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_454_5084)">
        <path
          d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z"
          fill="#FDE9C8"
        />
        <rect
          x="3.56731"
          y="9.32366"
          width="16.6154"
          height="6.35304"
          rx="3.17652"
          stroke="#977334"
          strokeWidth="1.38462"
        />
        <path
          d="M17.6505 11.4075C17.6336 11.375 17.6082 11.3479 17.5769 11.3289C17.5456 11.3099 17.5098 11.2998 17.4732 11.2998H14.6716C14.635 11.2998 14.5991 11.3099 14.5678 11.3289C14.5366 11.3479 14.5111 11.3752 14.4942 11.4076C14.4773 11.4401 14.4697 11.4766 14.4721 11.5131C14.4745 11.5496 14.4869 11.5848 14.5079 11.6148L15.9087 13.6159C15.9272 13.6422 15.9517 13.6636 15.9802 13.6784C16.0087 13.6932 16.0403 13.7009 16.0724 13.7009C16.1045 13.7009 16.1361 13.6932 16.1646 13.6784C16.1931 13.6636 16.2176 13.6422 16.2361 13.6159L17.6369 11.6148C17.6579 11.5848 17.6703 11.5496 17.6727 11.513C17.6751 11.4765 17.6674 11.44 17.6505 11.4075Z"
          fill="#977334"
        />
      </g>
      <defs>
        <clipPath id="clip0_454_5084">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
